import { LineItem } from 'apps/cart/types';

import {
  DISCOUNT_TYPES,
  DISCOUNTS_DISPLAYED_IN_LINE_ITEM,
  DISCOUNTS_DISPLAYED_IN_SUBTOTAL,
} from './appConstants';

const numberOrZero = (possibleNum: any) =>
  typeof possibleNum === 'number' && !isNaN(possibleNum) ? possibleNum : 0;

export const buildLineItemPricing = (lineItem: LineItem) => {
  const discounts = {
    [DISCOUNT_TYPES.COMMITMENT]: numberOrZero(
      Math.abs(
        parseFloat(lineItem.commitment_reward_adjustment_total as string)
      )
    ),
    [DISCOUNT_TYPES.MEMBERSHIP]: numberOrZero(
      Math.abs(parseFloat(lineItem.membership_discount_total as string))
    ),
    [DISCOUNT_TYPES.PROMO_CODE]: numberOrZero(
      Math.abs(parseFloat(lineItem.promo_total as string))
    ),
    [DISCOUNT_TYPES.SALE_PRICE]: numberOrZero(
      Math.abs(parseFloat(lineItem.sale_adjustment_total as string))
    ),
  };

  const totalDiscount = Object.values(discounts).reduce(
    (acc, cur) => acc + cur,
    0
  );

  const totalDiscountDisplayedInLineItem = Object.keys(discounts)
    .filter(discount => DISCOUNTS_DISPLAYED_IN_LINE_ITEM.includes(discount))
    .reduce((acc, cur) => acc + discounts[cur], 0);

  const totalDiscountDisplayedInSubtotal = Object.keys(discounts)
    .filter(discount => DISCOUNTS_DISPLAYED_IN_SUBTOTAL.includes(discount))
    .reduce((acc, cur) => acc + discounts[cur], 0);

  const originalPrice = numberOrZero(
    parseFloat(lineItem.non_membership_total as string)
  );
  const totalPrice = numberOrZero(
    originalPrice - totalDiscountDisplayedInLineItem
  );

  const displayDiscount =
    totalDiscountDisplayedInLineItem > 0 &&
    DISCOUNTS_DISPLAYED_IN_LINE_ITEM.some(discount => discounts[discount] > 0);

  let discountContentKey: string = null;

  if (displayDiscount) {
    /*
      Line item discount fallback logic
    */
    discountContentKey = DISCOUNTS_DISPLAYED_IN_LINE_ITEM.find(
      discount => discounts[discount] > 0
    )
      .split('/')
      .pop();
  }

  return {
    discounts,
    discountContentKey,
    displayDiscount,
    originalPrice,
    totalDiscount,
    totalDiscountDisplayedInLineItem,
    totalDiscountDisplayedInSubtotal,
    totalPrice,
  };
};
